<p-card [styleClass]="'h-full flex flex-column overflow-hidden'">
  <div class="flex-auto overflow-y-auto overflow-x-hidden">
  <ng-container *ngIf="!loading; else skel">
    <form *ngIf="form" [formGroup]="form" (ngSubmit)="save()" class="w-full">

      <!-- Page Title -->
      <h2 class="text-2xl font-semibold mt-0 mb-4">{{ 'home.title' | translate }}</h2>

      <!-- Application Status Section -->
      <div class="mb-5 pb-4 border-bottom-1 surface-border">
        <div class="flex flex-column md:flex-row gap-3">
          <div class="w-full md:w-4">
            <h3 class="text-lg font-medium mt-0 mb-2">{{ 'home.applicationStatus' | translate }}</h3>
            <p class="text-color-secondary mt-0 mb-0 text-sm line-height-3">
              {{ 'home.applicationStatusDesc' | translate }}
            </p>
          </div>
          <div class="w-full md:w-8">
            <p-dropdown
              formControlName="application_status"
              [options]="statusOptions"
              optionLabel="label"
              optionValue="value"
              [showClear]="false"
              styleClass="w-full md:w-auto"
              [style]="{'min-width': '250px', 'max-width': '100%'}">
            </p-dropdown>
          </div>
        </div>
      </div>

      <!-- Maintenance Start Date Section -->
      <div class="mb-5 pb-4 border-bottom-1 surface-border">
        <div class="flex flex-column md:flex-row gap-3">
          <div class="w-full md:w-4">
            <h3 class="text-lg font-medium mt-0 mb-2">{{ 'home.maintenanceStartDate' | translate }}</h3>
            <p class="text-color-secondary mt-0 mb-0 text-sm line-height-3">
              {{ 'home.maintenanceStartDateDesc' | translate }}
            </p>
          </div>
          <div class="w-full md:w-8">
            <p-calendar
              formControlName="maintenance_start_date"
              [showTime]="true"
              hourFormat="24"
              appendTo="body"
              styleClass="w-full md:w-auto"
              [style]="{'min-width': '250px', 'max-width': '100%'}">
            </p-calendar>
          </div>
        </div>
      </div>

      <!-- Maintenance Duration Section -->
      <div class="mb-5 pb-4 border-bottom-1 surface-border">
        <div class="flex flex-column md:flex-row gap-3">
          <div class="w-full md:w-4">
            <h3 class="text-lg font-medium mt-0 mb-2">{{ 'home.maintenanceDuration' | translate }}</h3>
            <p class="text-color-secondary mt-0 mb-0 text-sm line-height-3">
              {{ 'home.maintenanceDurationDesc' | translate }}
            </p>
          </div>
          <div class="w-full md:w-8">
            <div class="flex flex-column gap-3">
              <div class="flex align-items-center gap-3">
                <label class="text-color-secondary text-sm w-6rem flex-shrink-0">{{ 'home.minDays' | translate }}</label>
                <p-inputNumber formControlName="maintenance_minimum_days" [useGrouping]="false" styleClass="w-full md:w-auto" [style]="{'max-width': '150px'}"></p-inputNumber>
              </div>
              <div class="flex align-items-center gap-3">
                <label class="text-color-secondary text-sm w-6rem flex-shrink-0">{{ 'home.maxDays' | translate }}</label>
                <p-inputNumber formControlName="maintenance_maximum_days" [useGrouping]="false" styleClass="w-full md:w-auto" [style]="{'max-width': '150px'}"></p-inputNumber>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Release Date Section -->
      <div class="mb-5 pb-4 border-bottom-1 surface-border">
        <div class="flex flex-column md:flex-row gap-3">
          <div class="w-full md:w-4">
            <h3 class="text-lg font-medium mt-0 mb-2">{{ 'home.releaseDate' | translate }}</h3>
            <p class="text-color-secondary mt-0 mb-0 text-sm line-height-3">
              {{ 'home.releaseDateDesc' | translate }}
            </p>
          </div>
          <div class="w-full md:w-8">
            <p-calendar
              formControlName="release_date"
              [showTime]="true"
              hourFormat="24"
              appendTo="body"
              styleClass="w-full md:w-auto"
              [style]="{'min-width': '250px', 'max-width': '100%'}">
            </p-calendar>
          </div>
        </div>
      </div>

      <!-- App Versions Section -->
      <div class="mb-5 pb-4 border-bottom-1 surface-border">
        <div class="flex flex-column md:flex-row gap-3">
          <div class="w-full md:w-4">
            <h3 class="text-lg font-medium mt-0 mb-2">{{ 'home.appVersions' | translate }}</h3>
            <p class="text-color-secondary mt-0 mb-0 text-sm line-height-3">
              {{ 'home.appVersionsDesc' | translate }}
            </p>
          </div>
          <div class="w-full md:w-8">
            <div class="flex flex-column gap-3">
              <!-- Web -->
              <div class="flex align-items-center gap-3">
                <label class="text-color-secondary text-sm w-8rem flex-shrink-0">{{ 'home.webMin' | translate }}</label>
                <input pInputText formControlName="web_min_version" class="w-full md:w-auto" [style]="{'max-width': '150px'}">
              </div>
              <div class="flex align-items-center gap-3">
                <label class="text-color-secondary text-sm w-8rem flex-shrink-0">{{ 'home.webLatest' | translate }}</label>
                <input pInputText formControlName="web_latest_version" class="w-full md:w-auto" [style]="{'max-width': '150px'}">
              </div>

              <!-- Android -->
              <div class="flex align-items-center gap-3 mt-2">
                <label class="text-color-secondary text-sm w-8rem flex-shrink-0">{{ 'home.androidMin' | translate }}</label>
                <input pInputText formControlName="android_min_version" class="w-full md:w-auto" [style]="{'max-width': '150px'}">
              </div>
              <div class="flex align-items-center gap-3">
                <label class="text-color-secondary text-sm w-8rem flex-shrink-0">{{ 'home.androidLatest' | translate }}</label>
                <input pInputText formControlName="android_latest_version" class="w-full md:w-auto" [style]="{'max-width': '150px'}">
              </div>

              <!-- iOS -->
              <div class="flex align-items-center gap-3 mt-2">
                <label class="text-color-secondary text-sm w-8rem flex-shrink-0">{{ 'home.iosMin' | translate }}</label>
                <input pInputText formControlName="ios_min_version" class="w-full md:w-auto" [style]="{'max-width': '150px'}">
              </div>
              <div class="flex align-items-center gap-3">
                <label class="text-color-secondary text-sm w-8rem flex-shrink-0">{{ 'home.iosLatest' | translate }}</label>
                <input pInputText formControlName="ios_latest_version" class="w-full md:w-auto" [style]="{'max-width': '150px'}">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Save Button -->
      <div class="flex justify-content-end">
        <button pButton type="submit" [label]="'home.saveChanges' | translate" icon="pi pi-save" [disabled]="saving || !form.dirty"></button>
      </div>

    </form>
  </ng-container>

  <ng-template #skel>
    <p-skeleton width="100%" height="14rem"></p-skeleton>
  </ng-template>
  </div>
</p-card>
